import React, {useContext, useEffect} from 'react';
import { RouteProps, Routes, Route } from 'react-router-dom';
import { GenericTaskDetails } from '../journey-tasks/generic-task-details';
import { SelectEntity } from '../select-entity/select-entity';
import { FeatureToggleContext } from "../../config/toggle.context";
import { useUser } from '../../stores/user/user.hooks';
import useRouteNavigator from '../../shared/hooks/use-route-navigator';
import { JourneyEntity } from '../select-entity/journey';


export const EntityRoutesSwitch: React.FC<RouteProps> = ({ children, ...rest }) => {
  const { useToggle, toggles } = useContext(FeatureToggleContext);
  const toggleReadableUrl = useToggle("ftReadableUrlPaths");

  const genericTaskDetailsPath = toggleReadableUrl('/journey/:journeyId/task/:taskId', '/journey/:journeyName/task/:taskName');
  const {determineRouteNavigation} = useRouteNavigator()

 const user:any = useUser()
   useEffect(() =>{
 
     if(user.user_role && user.actions){
       determineRouteNavigation(user.user_role, user.actions)
     }
 
   },[user])

  return (
    <Routes>
      <Route  path='/journey' element={<JourneyEntity />} />
       <Route  path='/select-entity' element={<SelectEntity />}/>
      <Route  path={genericTaskDetailsPath} element={<GenericTaskDetails />} />
    </Routes>
  );
};
